<h1 mat-dialog-title>
  {{data.title}}

  <button mat-icon-button class="close-button" (click)="closeDialog(false)">
    <mat-icon>close</mat-icon>
  </button>
</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button color="warn" (click)="closeDialog(false)">{{data.buttonTextCancel}}</button>
  <button mat-flat-button color="primary" cdkFocusInitial (click)="closeDialog(true)">{{data.buttonTextConfirm}}</button>
</div>
